












import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseInputFile from "@/components/BaseInputFile";
import BaseThumbnailButton from "@/components/BaseThumbnailButton";

export default defineComponent({
  name: "MediaFileAddButton",
  components: { BaseButton, BaseInputFile, BaseThumbnailButton },
  props: {
    accept: { type: Array as () => string[] | undefined, required: false },
    multiple: { type: Boolean, default: false },
    mobileHideText: { type: Boolean, default: false },
    title: { type: String },
  },
});
